var skin_tone = document.getElementById("skin_tone");
var hair_tone = document.getElementById("hair_tone");
var ipl_funktioniert_title = document.getElementById("ipl_funktioniert_title");
var ipl_funktioniert_result = document.getElementById("ipl_funktioniert_result");
var ipl_result_geht = document.getElementById("ipl_result_geht");
var ipl_result_geht_nicht = document.getElementById("ipl_result_geht_nicht");

var tone_skin_sehr_hell = document.getElementById("tone_skin_sehr_hell");
var tone_skin_hell = document.getElementById("tone_skin_hell");
var tone_skin_normal = document.getElementById("tone_skin_normal");
var tone_skin_braun = document.getElementById("tone_skin_braun");
var tone_skin_dunkel = document.getElementById("tone_skin_dunkel");

var tone_hair_blond = document.getElementById("tone_hair_blond");
var tone_hair_dunkelblond = document.getElementById("tone_hair_dunkelblond");
var tone_hair_braun = document.getElementById("tone_hair_braun");
var tone_hair_rot = document.getElementById("tone_hair_rot");
var tone_hair_dunkelbraun = document.getElementById("tone_hair_dunkelbraun");
var tone_hair_schwarz = document.getElementById("tone_hair_schwarz");
var tone_hair_grau = document.getElementById("tone_hair_grau");

var skin_tone_result = "";
var hair_tone_result = "";

function clickedSkinTone(id){
  console.log("Clicked on: " + id);
  skin_tone_result = id;
   skin_tone.style.display = "none";
   hair_tone.style.display = "block";
  ipl_funktioniert_title.innerHTML = "Wähle deine Haarfarbe";
}

function clickedHairTone(id){
  console.log("Clicked on: " + id);
  hair_tone_result = id;
  hair_tone.style.display = "none";
  ipl_funktioniert_title.style.display = "none";
  ipl_funktioniert_result.style.display = "block";
  auswertung();
}

function auswertung(){
  if(skin_tone_result == "tone_skin_sehr_hell" ||
    skin_tone_result == "tone_skin_hell" ||
    skin_tone_result == "tone_skin_normal" ||
    skin_tone_result == "tone_skin_braun") {
      if(hair_tone_result == "tone_hair_blond" ||
        hair_tone_result == "tone_hair_rot" ||
        hair_tone_result == "tone_hair_grau"){
        ipl_funktioniert_result.innerHTML = "Ja! Basierend auf deiner Hautfarbe und deiner Haarfarbe, sollte unser Belle Body IPL perfekt zu dir passen. Bestell jetzt und fühl dich bald überall seidig-glatt.<br><br>Bitte beachte, dass die IPL-Haarentfernung am Wenigsten wirksam bei sehr blondem, weißem, grauem oder rotem Haar ist, da hier im Haar weniger Melanin vorhanden ist. Halte dich unbedingt an die Intensitätsstufen aus unserem Handbuch, für eine optimale Wirkung. Möglicherweise benötigst du länger für erste Ergebnisse, als Personen mit dunklerem Haar.";
      } else {
        ipl_funktioniert_result.innerHTML = "Ja! Basierend auf deiner Hautfarbe und deiner Haarfarbe, sollte unser Belle Body IPL perfekt zu dir passen. Bestell jetzt und fühl dich bald überall seidig-glatt.";
      }
      ipl_result_geht.style.display = "block";  
  } else {
      ipl_funktioniert_result.innerHTML = "Aufgrund deiner Haut- und Haarfarbe ist der IPL wahrscheinlich nicht die richtige Wahl für dich. Der IPL benötigt mehr Kontrast zwischen Haut und Haar, um seine Wirkung zu entfalten! Aber probier unseren Haarentfernungsschaum aus, dieser funktioniert für alle Haut- und Haartypen!";
      ipl_result_geht_nicht.style.display = "block";  
  }
  skin_tone_result = "";
  hair_tone_result = "";
}

function nochEinmalStarten(){
  skin_tone.style.display = "block";
  ipl_funktioniert_title.innerHTML = "Wähle deine Hautfarbe";
  ipl_funktioniert_title.style.display = "block";
  ipl_funktioniert_result.style.display = "none";
  ipl_result_geht.style.display = "none";
  ipl_result_geht_nicht.style.display = "none";
}